import type { IQuoteScr } from '@/interfaces'

export class QuoteScr implements IQuoteScr {
	scrId: number
	status: string
	scrLinesList: string[]
	approvalDate: Date
	rejectDate: Date
	requestDate: Date
	rejectReason: string
	approveByOps: number
	rejectByOps: number
	approveByFin: number
	rejectByFin: number
	notes: string

	constructor({
		scrId,
		status,
		scrLinesList,
		approvalDate,
		rejectDate,
		requestDate,
		approveByOps,
		rejectByOps,
		approveByFin,
		rejectByFin,
		rejectReason,
		notes
	}: IQuoteScr) {
		this.scrId = scrId
		this.status = status
		this.scrLinesList = scrLinesList
		this.approvalDate = approvalDate
		this.requestDate = requestDate
		this.rejectDate = rejectDate
		this.rejectReason = rejectReason
		this.approveByOps = approveByOps
		this.rejectByOps = rejectByOps
		this.approveByFin = approveByFin
		this.rejectByFin = rejectByFin
		this.notes = notes
	}
}
